import { AbpMultiTenancyService } from '@abp/multi-tenancy/abp-multi-tenancy.service';
import { Injectable } from '@angular/core';
import {
    ApplicationInfoDto,
    GetCurrentLoginInformationsOutput,
    SessionServiceProxy,
    TenantLoginInfoDto,
    UserLoginInfoDto,
    UserRegisteredAgentServiceProxy,
    UserDto,
    UserServiceProxy
} from '@shared/service-proxies/service-proxies';
import { AppConsts } from '@shared/AppConsts';

@Injectable()
export class AppSessionService {

    private _user: UserLoginInfoDto;
    private _userDetails: UserDto;
    private _tenant: TenantLoginInfoDto;
    private _application: ApplicationInfoDto;
    private _isRaPortal: boolean;
    private _raListOfCurrentUser: any[];

    constructor(
        private _sessionService: SessionServiceProxy,
        private _userRegisteredAgentService: UserRegisteredAgentServiceProxy,
        private _userService: UserServiceProxy,
        private _abpMultiTenancyService: AbpMultiTenancyService) {
    }

    get application(): ApplicationInfoDto {
        return this._application;
    }

    // redundant - built in abp user information
    // use userDetails instead
    get user(): UserLoginInfoDto {
        return this._user;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

    get isRaPortal(): boolean {
        return this._isRaPortal;
    }

    get raListForCurrentUser(): any[] {
        return this._raListOfCurrentUser;
    }

    setRaListForRaPortal(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if (abp.auth.isGranted(AppConsts.Permissions.Portal_RegisteredAgent)) {
                // gets only the default RA since OnlyDefault is set to true
                this._userRegisteredAgentService.getAll(true, true, abp.session.userId, undefined, undefined, undefined).toPromise()
                .then(result => {
                    this._raListOfCurrentUser = result.items;
                    resolve(true);
                }, (err) => {
                    reject(err);
                });
            } else{
                resolve(true);
            }
        });
    }
    // user details contain all user information
    get userDetails(): UserDto {
        return this._userDetails;
    }

    getShownLoginName(): string {
        const userName = this._user.userName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return userName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    }

    init(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            this._sessionService.getCurrentLoginInformations().toPromise().then((result: GetCurrentLoginInformationsOutput) => {
                this._application = result.application;
                this._user = result.user;
                this._tenant = result.tenant;
                if(result.user) {
                    this._userService.get(result.user.id).toPromise().then((userInfo: UserDto) => {
                        this._userDetails = userInfo;
                        resolve(true);
                    }, (err) => {
                        reject(err);
                    });
                } else {
                    resolve(true);
                }
            }, (err) => {
                reject(err);
            });
        });
    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }

        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
